window._addMeToCart = function(e, el) {
  e.preventDefault();
  
  // Get the variant ID from the clicked element
  let variantId = el.getAttribute('data-variant_id');

  if (!variantId) {
    console.error('No variant ID found.');
    return;
  }

  // Prepare the form data to add the product to the cart
  let formData = {
    'items': [
      {
        'id': variantId,
        'quantity': 1
      }
    ]
  };

  // Fetch request to add the product to the cart
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(data => {
    // Trigger the drawer to open by dispatching the 'cart:refresh' event
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));

    // Optionally, dispatch the 'product:added' event for further customization
    document.dispatchEvent(new CustomEvent('product:added', {
      bubbles: true,
      detail: {
        variant: data.items[0]
      }
    }));
  })
  .catch(err => console.error('Error:', err));
};

document.addEventListener('DOMContentLoaded', function() {
    const prevButton = document.querySelector('.prev');
    const nextButton = document.querySelector('.next');
    const galleryItems = document.querySelectorAll('.product-gallery__media.snap-center'); // All gallery items
    const totalItems = galleryItems.length; // Total number of images

    let activeIndex = 0; // Start with the first image as active

    // Function to update the visibility of prev and next buttons based on the current active slide
    function updateArrowVisibility() {
        // Hide or show the prev button based on the active index
        if (activeIndex === 0) {
            prevButton.style.opacity = '0'; // Hide the prev button for the first image
            prevButton.style.pointerEvents = 'none'; // Disable interaction when hidden
        } else {
            prevButton.style.opacity = '0'; // Initially hide, will fade in on hover
            prevButton.style.pointerEvents = 'none'; // Disable interaction initially
        }

        // Hide or show the next button based on the active index
        if (activeIndex === totalItems - 1) {
            nextButton.style.opacity = '0'; // Hide the next button for the last image
            nextButton.style.pointerEvents = 'none'; // Disable interaction when hidden
        } else {
            nextButton.style.opacity = '0'; // Initially hide, will fade in on hover
            nextButton.style.pointerEvents = 'none'; // Disable interaction initially
        }
    }

    // Function to update the active image class
    function updateActiveImage() {
        // Remove the active class from all images
        galleryItems.forEach(item => {
            item.classList.remove('active');
        });

        // Add the active class to the current image
        galleryItems[activeIndex].classList.add('active');
    }

    // Function to show the arrows only when hovering (including hovering over the arrows)
    function handleHover(isHovering) {
        if (isHovering) {
            // Show prev button if not on the first image
            if (activeIndex > 0) {
                prevButton.style.opacity = '1';
                prevButton.style.pointerEvents = 'auto';
            }
            // Show next button if not on the last image
            if (activeIndex < totalItems - 1) {
                nextButton.style.opacity = '1';
                nextButton.style.pointerEvents = 'auto';
            }
        } else {
            // Hide arrows when not hovering
            prevButton.style.opacity = '0';
            nextButton.style.opacity = '0';
            prevButton.style.pointerEvents = 'none';
            nextButton.style.pointerEvents = 'none';
        }
    }

    // Initial setup when the page loads
    updateArrowVisibility();
    updateActiveImage();

    // Add hover event listeners to the gallery container AND the arrow buttons
    galleryItems.forEach(item => {
        item.addEventListener('mouseenter', () => handleHover(true)); // Show arrows on hover
        item.addEventListener('mouseleave', () => handleHover(false)); // Hide arrows when not hovering
    });

    // Keep the arrows visible if hovering over them
    prevButton.addEventListener('mouseenter', () => handleHover(true));
    nextButton.addEventListener('mouseenter', () => handleHover(true));
    prevButton.addEventListener('mouseleave', () => handleHover(false));
    nextButton.addEventListener('mouseleave', () => handleHover(false));

    // Event listeners for carousel navigation
    prevButton.addEventListener('click', function() {
        if (activeIndex > 0) {
            activeIndex--; // Move to the previous image
            updateActiveImage(); // Update active class
            updateArrowVisibility(); // Update button visibility
        }
    });

    nextButton.addEventListener('click', function() {
        if (activeIndex < totalItems - 1) {
            activeIndex++; // Move to the next image
            updateActiveImage(); // Update active class
            updateArrowVisibility(); // Update button visibility
        }
    });
});

if (!customElements.get('custom-countdown-timer')) {
  class CustomCountdownTimer extends HTMLElement {
    constructor() {
      super();
      var _this = this;
      this.elements = {
        days: this.querySelector('.day .num'),
        hours: this.querySelector('.hour .num'),
        minutes: this.querySelector('.min .num'),
        seconds: this.querySelector('.sec .num'),
      }

      // Parsing the existing MM-DD-YYYY format directly
      let splittedTargetDate = this.dataset.date.split('-');
      let splittedTargetTime = this.dataset.time.split(':');

      this.targetDate = {
        day: parseInt(splittedTargetDate[1]), // Day
        month: parseInt(splittedTargetDate[0]) - 1, // Month, zero-based
        year: parseInt(splittedTargetDate[2]), // Year
        hour: parseInt(splittedTargetTime[0]), // Hour
        minute: parseInt(splittedTargetTime[1]), // Minute
        timezoneOffset: parseInt(this.dataset.timezoneOffset), // Timezone offset
      }

      let userTime = new Date();
      let userTimezoneOffset = userTime.getTimezoneOffset() * 60000;

      this.countDownDate = new Date(this.targetDate.year, this.targetDate.month, this.targetDate.day, this.targetDate.hour, this.targetDate.minute, 0, 0).getTime() - this.targetDate.timezoneOffset - userTimezoneOffset;
      
      this.interval = setInterval(_this.updateTime, 1000, _this);
      this.updateTime(_this);
    }

    updateTime(_this) {
      const now = new Date().getTime();
      const distance = _this.countDownDate - now;

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      _this.elements.days.innerHTML = _this.addZero(days);
      _this.elements.hours.innerHTML = _this.addZero(hours);
      _this.elements.minutes.innerHTML = _this.addZero(minutes);
      _this.elements.seconds.innerHTML = _this.addZero(seconds);

      if (distance < 0) {
        _this.innerHTML = "EXPIRED";
        clearInterval(_this.interval);
      }
    }

    addZero(x) {
      return (x < 10 && x >= 0) ? "0" + x : x;
    }
  }

  customElements.define('custom-countdown-timer', CustomCountdownTimer);
}

/* =========================================================================
   Product card photo swiper — mechanics ported from ASRV V3, TN-adapted.
   - Touch: native scroll-snap swiping (plus direction-lock inside carousels)
   - Desktop: simulated click-and-drag with commit threshold + arrow buttons
   - Infinite loop via edge clones: [cloneLast, 1..N, cloneFirst]; after a
     swipe settles on a clone we jump instantly to its real twin — seamless
     because the pixels are identical.
   - Works in stacked collection grids AND inside scroll-carousel sections
   Real slides are queried dynamically so the swatch AJAX can swap track
   contents and just call __refreshProductCardGallery — no re-binding.
   ========================================================================= */
(function () {
  function isTouch() {
    return window.matchMedia && window.matchMedia('(hover: none)').matches;
  }

  function setupGallery(card) {
    if (card.dataset.galleryBound === '1') return;
    var figure = card.querySelector('.product-card__figure');
    if (!figure) return;
    var track = figure.querySelector('[data-gallery-track]');
    if (!track) return;

    var prev = figure.querySelector('[data-card-prev]');
    var next = figure.querySelector('[data-card-next]');
    var index = 0;           // real slide index, 0..N-1
    var pointerDown = false; // finger or mouse currently on the track

    function realSlides() {
      return track.querySelectorAll('.product-gallery__media:not([data-gallery-clone])');
    }

    // First interaction with the gallery -> warm every image of every
    // colorway on this card (handled by product-swatch-ajax.js).
    function prime() {
      hintDone = true; // shopper already knows it swipes — skip the hint
      if (window.__preloadCardColorways) window.__preloadCardColorways(card);
    }

    function makeClone(el) {
      var c = el.cloneNode(true);
      c.setAttribute('data-gallery-clone', '');
      c.setAttribute('aria-hidden', 'true');
      c.classList.remove('active');
      return c;
    }

    // [cloneLast][real 0..N-1][cloneFirst] — physical position = real index + 1
    function buildClones() {
      track.querySelectorAll('[data-gallery-clone]').forEach(function (c) { c.remove(); });
      var real = realSlides();
      if (real.length < 2) return;
      track.insertBefore(makeClone(real[real.length - 1]), real[0]);
      track.appendChild(makeClone(real[0]));
    }

    function applyVisuals() {
      var media = realSlides();
      for (var i = 0; i < media.length; i++) {
        media[i].classList.toggle('active', i === index);
      }
      var looping = media.length > 1;
      if (prev) prev.classList.toggle('is-ready', looping);
      if (next) next.classList.toggle('is-ready', looping);
    }

    // Position by exact fractional geometry. offsetLeft/clientWidth are
    // integer-rounded while the real layout is fractional, so anything
    // rounded leaves a subpixel sliver of the neighboring slide visible.
    function exactLeft(el) {
      return el.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
    }

    function scrollToPhysical(p, smooth) {
      var kids = track.querySelectorAll('.product-gallery__media');
      var left = kids[p] ? exactLeft(kids[p]) : p * slideWidth();
      track.scrollTo({ left: left, behavior: smooth ? 'smooth' : 'auto' });
    }

    // Belt and suspenders: clones are only visible while a gesture/animation
    // is in flight. At rest they're hidden, so no rounding artifact can ever
    // bleed a previous-image hairline into the card edge.
    function setClonesVisible(on) {
      track.querySelectorAll('[data-gallery-clone]').forEach(function (c) {
        c.style.visibility = on ? '' : 'hidden';
      });
    }

    function slideWidth() {
      var first = track.querySelector('.product-gallery__media');
      var w = first ? first.getBoundingClientRect().width : 0;
      return w || track.clientWidth || 1;
    }

    // i may be -1 (wrap to last) or N (wrap to first); the clone at that
    // physical position is scrolled to smoothly, then normalize() snaps us
    // to the real twin once the animation settles.
    function wrappedScrollTo(i, smooth) {
      scrollToPhysical(i + 1, smooth);
    }

    function physicalPos() {
      return Math.round(track.scrollLeft / slideWidth());
    }

    // If we're parked on a clone, jump instantly to its real twin (identical
    // pixels, invisible). Called after a swipe settles AND at the start of
    // every new gesture — otherwise a fast follow-up swipe would launch from
    // the clone and smooth-scroll all the way back across the strip.
    function normalizeNow() {
      var n = realSlides().length;
      if (n < 2) return;
      var pos = physicalPos();
      var kids = track.querySelectorAll('.product-gallery__media');
      if (pos === 0) {                                     // on cloneLast → real last
        track.scrollLeft = kids[n] ? exactLeft(kids[n]) : n * slideWidth();
        index = n - 1;
      } else if (pos === n + 1) {                          // on cloneFirst → real first
        track.scrollLeft = kids[1] ? exactLeft(kids[1]) : slideWidth();
        index = 0;
      }
    }

    function normalize() {
      if (pointerDown) return;
      if (track.dataset.hintActive === '1') return;
      normalizeNow();
      // Re-align exactly on every settle — kills residual fractions from
      // native snap rounding or mid-flight layout shifts.
      scrollToPhysical(index + 1, false);
      setClonesVisible(false);
    }

    var settleTimer = null;
    function onScroll() {
      if (track.clientWidth === 0) return;
      var n = realSlides().length;
      if (n === 0) return;
      var pos = physicalPos();
      var newIndex;
      if (pos <= 0) newIndex = n - 1;
      else if (pos >= n + 1) newIndex = 0;
      else newIndex = pos - 1;
      if (newIndex !== index) {
        index = newIndex;
        applyVisuals();
      }
      clearTimeout(settleTimer);
      settleTimer = setTimeout(normalize, 150);
    }

    track.addEventListener('scroll', onScroll, { passive: true });

    if (prev) {
      prev.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        prime();
        setClonesVisible(true);
        normalizeNow();
        wrappedScrollTo(index - 1, true);
      });
    }
    if (next) {
      next.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        prime();
        setClonesVisible(true);
        normalizeNow();
        wrappedScrollTo(index + 1, true);
      });
    }

    // Kill native image drag on the track and wrapping anchor so mouse events
    // aren't hijacked by the browser's drag-and-drop API.
    track.addEventListener('dragstart', function (ev) { ev.preventDefault(); });
    var mediaLink = track.closest('.product-card__media');
    if (mediaLink) {
      mediaLink.addEventListener('dragstart', function (ev) { ev.preventDefault(); });
    }

    // Desktop click-and-drag (mouse-only; touch uses native scroll-snap).
    var dragging = false;
    var startX = 0;
    var startScroll = 0;
    var startIndex = 0;
    var moved = 0;
    var DRAG_THRESHOLD = 5;
    var COMMIT_RATIO = 0.05; // drag >5% of width commits to next/prev

    track.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      prime();
      setClonesVisible(true);
      normalizeNow();
      dragging = true;
      pointerDown = true;
      moved = 0;
      startX = e.pageX;
      startScroll = track.scrollLeft;
      startIndex = index;
      track.classList.add('is-grabbing');
    });

    window.addEventListener('mousemove', function (e) {
      if (!dragging) return;
      var delta = e.pageX - startX;
      moved = Math.abs(delta);
      track.scrollLeft = startScroll - delta;
    });

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      pointerDown = false;
      var w = slideWidth();
      var scrollDelta = track.scrollLeft - startScroll;
      var target = startIndex;
      if (Math.abs(scrollDelta) >= w * COMMIT_RATIO) {
        target = startIndex + (scrollDelta > 0 ? 1 : -1); // may be -1 or N: wraps
      }
      // Keep snap disabled through the release animation so scroll-snap
      // doesn't fight the smooth scrollTo and yank us back.
      wrappedScrollTo(target, true);
      setTimeout(function () {
        track.classList.remove('is-grabbing');
      }, 350);
    }
    window.addEventListener('mouseup', endDrag);
    window.addEventListener('mouseleave', endDrag);

    // A real drag must not click through to the PDP.
    track.addEventListener('click', function (e) {
      if (moved > DRAG_THRESHOLD) {
        e.preventDefault();
        e.stopPropagation();
        moved = 0;
      }
    }, true);

    // Track finger presence so normalize() never jumps mid-gesture.
    track.addEventListener('touchstart', function () { setClonesVisible(true); normalizeNow(); pointerDown = true; prime(); }, { passive: true });
    // Trackpad/wheel horizontal scrolling has no mousedown — reveal clones there too.
    track.addEventListener('wheel', function () { setClonesVisible(true); }, { passive: true });
    track.addEventListener('touchend', function () {
      pointerDown = false;
      clearTimeout(settleTimer);
      settleTimer = setTimeout(normalize, 150);
    }, { passive: true });
    track.addEventListener('touchcancel', function () { pointerDown = false; }, { passive: true });

    // Inside scroll-carousel sections the outer carousel also wants the drag.
    // Desktop: the theme's carousel adds a mouse-drag (pointer:fine only), so we
    // stop the pointer/mouse event on the image — the gallery's own drag wins on
    // the image, while dragging elsewhere on the card still pages the carousel.
    // Touch: the carousel binds NO touch handlers — it's a pure native scroll
    // container, and so is the gallery track. A horizontal swipe on the image
    // scrolls the innermost native scroller (the gallery), and the loop clones
    // keep it from ever chaining to the outer carousel mid-strip. So touch needs
    // no special handling and loops exactly like the stacked grid. (An earlier
    // direction-lock that called next.click() here fought the loop's own
    // native-scroll normalize and made the strip rewind to the first image.)
    var outerCarousel = card.closest('scroll-carousel[allow-drag]');
    if (outerCarousel) {
      figure.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
      figure.addEventListener('mousedown', function (e) { e.stopPropagation(); });
    }

    // Initial position: physical slot 1 (first real slide, past the leading
    // clone). Retry via rAF until the track has been laid out.
    function positionInit(tries) {
      if (track.clientWidth > 0) {
        scrollToPhysical(index + 1, false);
        return;
      }
      if (tries > 0) requestAnimationFrame(function () { positionInit(tries - 1); });
    }

    // Track resizes (image loads, scrollbars, breakpoint shifts) silently
    // invalidate the scroll offset — re-align whenever geometry changes.
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () {
        if (pointerDown || track.classList.contains('is-grabbing')) return;
        scrollToPhysical(index + 1, false);
      }).observe(track);
    }

    buildClones();
    positionInit(60);
    applyVisuals();
    card.dataset.galleryBound = '1';

    // Let the swatch AJAX reset us after it rebuilds the track contents.
    card.__resetGallery = function () {
      index = 0;
      buildClones();
      positionInit(60);
      applyVisuals();
    };
  }

  // One-time swipe hint (touch devices): the first swipeable gallery that
  // dwells at least half-visible in the viewport for 1s gets a gentle
  // nudge-and-return to cue that card images swipe. Once per page load;
  // cancelled for good the moment the shopper swipes one themselves.
  var hintDone = false;

  function runHint(track) {
    var base = track.scrollLeft;
    var nudge = Math.round(track.clientWidth * 0.24);
    var prevSnap = track.style.scrollSnapType;
    track.dataset.hintActive = '1';
    track.style.scrollSnapType = 'none';
    track.scrollTo({ left: base + nudge, behavior: 'smooth' });
    setTimeout(function () {
      track.scrollTo({ left: base, behavior: 'smooth' });
      setTimeout(function () {
        track.style.scrollSnapType = prevSnap;
        delete track.dataset.hintActive;
      }, 450);
    }, 780);
  }

  function setupHint() {
    if (hintDone) return;
    // Real touch devices — or the theme editor's mobile preview, which is a
    // narrow desktop iframe and never matches (hover: none).
    var editorMobile = window.Shopify && window.Shopify.designMode && window.innerWidth < 1000;
    if (!isTouch() && !editorMobile) return;
    if (!('IntersectionObserver' in window)) return;

    var dwell = new Map();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (hintDone) { io.disconnect(); return; }
        var card = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          if (dwell.has(card)) return;
          dwell.set(card, setTimeout(function () {
            if (hintDone) return;
            var track = card.querySelector('[data-gallery-track]');
            if (!track || track.clientWidth === 0) return;
            if (track.querySelectorAll('.product-gallery__media:not([data-gallery-clone])').length < 2) return;
            hintDone = true;
            io.disconnect();
            runHint(track);
          }, 1350));
        } else {
          var t = dwell.get(card);
          if (t) { clearTimeout(t); dwell.delete(card); }
        }
      });
    }, { threshold: [0, 0.5, 1] });

    document.querySelectorAll('product-card [data-gallery-track]').forEach(function (tr) {
      var card = tr.closest('product-card');
      if (card) io.observe(card);
    });
  }

  function init() {
    document.querySelectorAll('product-card').forEach(setupGallery);
    setupHint();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Catch ajax-added cards (pagination / filters / customizer section reloads)
  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.tagName === 'PRODUCT-CARD') setupGallery(n);
          else if (n.querySelectorAll) n.querySelectorAll('product-card').forEach(setupGallery);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  window.__refreshProductCardGallery = function (card) {
    if (!card) return;
    if (card.__resetGallery) card.__resetGallery();
    else setupGallery(card);
  };
})();
